import { render } from "./UserResponses.vue?vue&type=template&id=0f44fe3f&scoped=true&ts=true"
import script from "./UserResponses.vue?vue&type=script&lang=ts"
export * from "./UserResponses.vue?vue&type=script&lang=ts"

import "./UserResponses.vue?vue&type=style&index=0&id=0f44fe3f&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f44fe3f"]])

export default __exports__